import type { SelectOption } from '@/_components';
import { FormControl, FormItem, FormMessage } from '@/_components';

import { VariableTextInput, type VariableTextInputProps } from './variable-text-input';

export type FormVariableTextInputProps = VariableTextInputProps & {
  formItemClassName?: string;
  variableOptions?: SelectOption<string>[];
};

export function FormVariableTextInput({ formItemClassName, ...props }: FormVariableTextInputProps) {
  return (
    <FormItem className={formItemClassName}>
      <FormControl>
        <VariableTextInput {...props} />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
}
